import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import FormWrapper from '../../../../../library/form/components/FormWrapper';

const ProdIOOExoViewRow = (props) => {
    const { formObject, index, rowKey } = props;

        return (
            <ul className="uiDPEditLine">
                <li className="uiColumnCenter uiColumn50">
                    <span>{index}</span>
                </li>
                <li className="uiColumnCenter uiColumn150">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "id" }} />
                </li>
                <li className="uiColumnCenter uiColumn250">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        action={{ paramName: "actualItem", actionId: "show" }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
                <li className="uiColumnCenter uiColumn50">
                    <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "units" }} />
                </li>
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig" 
                    action={{ paramName: "variation1Name" }} >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation1" }} />
                </FormWrapper>
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig" 
                    action={{ paramName: "variation2Name" }} >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation2" }} />
                </FormWrapper>
                <li className="uiColumnCenter uiColumn90">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyRequired" }} />
                </li>
                <FormWrapper formObject={formObject} headerKey="viewConfig" action={{ paramName: "showCost" }} >
                    <li className="uiColumnCenter uiColumn90">
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "resUnitCost" }} />
                    </li>
                    <li className="uiColumnCenter uiColumn90">
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "processUnitCost" }} />
                    </li>
                    <li className="uiColumnCenter uiColumn90">
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "ohUnitCost" }} />
                    </li>
                    <li className="uiColumnCenter uiColumn90">
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "totalUnitCost" }} />
                    </li>
                </FormWrapper>
                <li className="uiColumnCenter uiColumn60 uiActionBlock">
                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="edit"
                        onlyIcon={true}
                        tooltip="Edit"
                        starIconClassName="uiColorNeutralAction"
                            action={{ actionId: "edit",  
                            paramName: "editBtn",
                            actionParam: {pathKey: "OEXO"}, containerKey: "popup" }}
                            className="" ></FormButton>
                    <FormButton formObject={formObject} rowKey={rowKey}
                            starIcon="clear"
                            onlyIcon={true}
                            tooltip="Delete"
                            starIconClassName="uiColorNegativeAction"
                            action={{ actionId: "del",  
                            paramName: "delBtn",
                            actionParam: {pathKey: "OEXO"}, containerKey: "row" }}
                            className="" ></FormButton>
                </li>
            </ul>
        )
}

export default ProdIOOExoViewRow